export default __webpack_public_path__ + "848ed65b23abfc59dbc8f428a9f10755.png";